import useSWR from 'swr'
import { getCacheKeyFromDocument } from './graphql-fetcher'
import { GET_CONTACT } from '../graphql/product/get-contact.graphql'
import { GET_CUSTOMER_NAVIGATION } from '../graphql/content/get-customer-navigation.graphql'
import { getCustomerNavigationAction } from '../actions/get-customer-navigation-action'
import { getContactAction } from '../actions/get-contact-action'
import { useAuth } from '@dustin-web/microsite-components/src/auth'
import type { GetContactQuery } from '../graphql/product/generated/graphql-types'
import type { GetCustomerNavigationQuery } from '../graphql/content/generated/graphql-types'

export const useAccountSwr = () => {
  const { isAuthenticated } = useAuth()
  const { data: contactQueryData, error: contactQueryError } = useSWR<GetContactQuery>(
    isAuthenticated ? getCacheKeyFromDocument(GET_CONTACT) : null,
    getContactAction
  )
  const { data: customerNavigationData, error: customerNavigationError } =
    useSWR<GetCustomerNavigationQuery>(
      isAuthenticated ? getCacheKeyFromDocument(GET_CUSTOMER_NAVIGATION) : null,
      getCustomerNavigationAction
    )

  return {
    contactQueryError,
    contactQueryData,
    customerNavigationData,
    customerNavigationError,
  }
}
